// sort the entities by intacctEntityId. This is the same as the order they appear in the dropdown in the Intacct UI.
// if intacctEntityId is falsy, it will be sorted to the front of the list
export const userEntityComparator = (a, b) => (a.intacctEntityId ?? '').localeCompare(b.intacctEntityId ?? '');
//# sourceMappingURL=miscellaneous.js.map